// The shell chip: which city and which niche this screen is about, read from the rows.

import { Link } from 'react-router-dom';
import { useNicheContext } from '../lib/nicheContext.js';

export function NicheChip() {
  const { label, activeVerticals, activeCities } = useNicheContext();
  if (label === '') return null;
  const title =
    `Активни градове: ${activeCities.map((c) => c.name_bg).join(', ') || '—'} · ` +
    `активни ниши: ${activeVerticals.map((v) => v.name_bg).join(', ') || '—'}`;
  return (
    <Link
      to="/admin"
      className="shell__tag"
      title={`${title} — кликнете за управление на ниши`}
      aria-label={`Активен пазар: ${label}`}
    >
      {label}
    </Link>
  );
}
